import type { MigrationStrategies } from 'rxdb';
import type { ElevationRangeDocument } from './elevationRange.types';

export const elevationRangeMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: ElevationRangeDocument) => ({
    ...oldDoc,
    fkParentArea: oldDoc.fkParentArea || 0,
    parentAreaName: oldDoc.parentAreaName || '',
    parentAreaPcsId: oldDoc.parentAreaPcsId || '',
  }),
};
